import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Checkbox,
  Stack,
  TextField,
  Typography,
  styled,
} from '@mui/material';

export const ReplenishmentRoot = styled(Stack)(({theme}) => ({
  gap: theme.spacing(3.5),
  minHeight: 454,
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: '793px',
  },
}));

export const FieldContainer = styled(Stack)(({theme}) => ({
  gap: theme.spacing(2),
}));

export const SectionTitle = styled(Typography)({
  fontFamily: 'Inter',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '24px',
  color: '#0C0C0D',
});

export const AmountInput = styled(TextField)({
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    background: '#FFFFFF',
    '& fieldset': {
      borderColor: '#D1D5DB',
    },
  },
  '& .MuiInputBase-input': {
    height: 42,
    padding: '8px 12px',
    fontFamily: 'Inter',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: '24px',
    color: '#7E8285',
  },
});

export const ContractHeader = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px',
});

export const LinkButton = styled(Button)({
  padding: '0 8px',
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  textAlign: 'center',
  color: '#0D99FF',
  textTransform: 'none',
});

export const ContractContainer = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'hasError',
})<{hasError?: boolean}>(({hasError}) => ({
  background: '#FFFFFF',
  border: `1px solid ${hasError ? '#FF5E5E' : '#D1D5DB'}`,
  borderRadius: '8px',
}));

export const CompanyTitle = styled(Typography)({
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '24px',
  color: '#000000',
});

export const RequisitesAccordion = styled(Accordion)({
  boxShadow: 'none',
  '&:before': {
    display: 'none',
  },
  '& .MuiAccordionSummary-root': {
    minHeight: 'auto',
    width: 'fit-content',
  },
  '& .MuiAccordionSummary-content': {
    margin: 0,
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: '#0D99FF',
  },
});

export const RequisitesSummary = styled(AccordionSummary)({
  height: '24px',
  minHeight: 'auto !important',
  padding: 0,
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '24px',
  textAlign: 'center',
  color: '#0D99FF',
});

export const RequisitesDetails = styled(AccordionDetails)({
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '22px',
});

export const ContractCheckbox = styled(Checkbox)({
  '&.MuiCheckbox-root': {
    padding: 0,
    width: '20px',
    height: '20px',
  },
});

export const Text = styled(Typography)({
  fontFamily: 'Inter',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '24px',
  color: '#000000',
});

export const SubText = styled(Typography)({
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '17px',
  color: '#868A8C',
});

export const PaymentMethodsContainer = styled(Stack)(({theme}) => ({
  gap: theme.spacing(1.5),
}));

export const PaymentButtonsContainer = styled(Stack)(({theme}) => ({
  gap: theme.spacing(1.25),
}));

export const PaymentMethodButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{active?: boolean}>(({active}) => ({
  padding: '12px 14px',
  width: '100%',
  maxWidth: '100%',
  justifyContent: 'flex-start',
  minHeight: '68px',
  background: '#FFFFFF',
  border: `1px solid ${active ? '#3AC977' : '#D1D5DB'}`,
  borderRadius: '8px',
  textTransform: 'none',
}));

export const PaymentMethodRow = styled(Stack)({
  width: '100%',
  flexDirection: 'row',
  gap: '12px',
  alignItems: 'center',
});

export const IconUnchecked = styled(RadioButtonUncheckedIcon)({
  color: '#C7C7C7',
  fontSize: '24px',
});

export const IconChecked = styled(CheckCircleIcon)({
  color: '#2196F3',
  fontSize: '24px',
});

export const PaymentMethodTextBlock = styled(Stack)({
  alignItems: 'flex-start',
});

export const PaymentMethodTitle = styled(Typography)({
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  color: '#0C0C0D',
  textTransform: 'none',
});

export const SubmitButton = styled(Button)({
  width: '223px',
  height: '39px',
  borderRadius: '8px',
  boxShadow: 'none',
  textTransform: 'none',
  backgroundColor: '#3AC977',
  '&:hover': {
    backgroundColor: '#32B66B',
    boxShadow: 'none',
  },
});

export const SubmitLabel = styled(Typography)({
  fontFamily: 'Inter',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '19px',
  color: '#FFFFFF',
});

export const SubmitContent = styled(Stack)({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
});
